import { UserOutlined } from '@ant-design/icons';
import { Avatar, Typography } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import Image from 'next/image';
import React from 'react';

import CardSliderType_2 from '../../ProjectPage/CardSlider/CardSliderType_2';
import { ShouldRender } from '../../shared/basic/ShouldRender';
import { getUserInitials } from '../../shared/getInitials';
import { LineLarge } from '../../../../assets';
import { ReadersCardsData } from '../../../utils/data';
import { ReadersCardsDataProps } from '../../../utils/interfaces';

const { Text } = Typography;

interface ScrollCardProps {
  data: ReadersCardsDataProps;
}

export const ScrollCard: React.FC<ScrollCardProps> = ({ data }) => {
  return (
    <div className=' md:w-2/3 xl:w-10/12 '>
      <div className='flex gap-x-5'>
        <div className='flex flex-col gap-y-5 '>
          <Text className='xl:text-[20px] min-h-32 text-fadedWhite'>
            {data?.comment}
          </Text>

          <div className='flex gap-x-4  text-sm '>
            <span className=''>
              <Avatar
                size={50}
                alt='profile-picture'
                className='bg-primary text-fadedWhite'
              >
                {getUserInitials(data?.name) || <UserOutlined />}
              </Avatar>
            </span>
            <span className='flex flex-col xl:gap-y-2 text-fadedWhite'>
              <span className='font-bold xl:text-[20px]'>{data.name}</span>
              <span className='italic  xl:text-[20px] leading-6 text-textGray'>
                {data.position}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const ReadersSection: React.FC = () => {
  const screens = useBreakpoint();
  return (
    <div>
      <div className='mt-14'>
        <span className='font-bold flex justify-center text-2xl xl:text-[36px]'>
          <div className='flex flex-col text-center sm:whitespace-nowrap xl:leading-10 text-fadedWhite'>
            <span className='font-bold md:w-min wh'>
              Love From Our Readers
              <div className='w-fit hidden md:flex '>
                <Image
                  src={LineLarge}
                  alt='LineLarge'
                  className='object-contain w-full h-full'
                />
              </div>
            </span>
          </div>
        </span>
      </div>
      <div className='py-10 lg:py-20 pl-4 xl:pl-28'>
        <ShouldRender check={screens.lg}>
          <CardSliderType_2>
            {ReadersCardsData?.map((item, index) => (
              <div
                key={`${item?.name}-${index}`}
                className='w-[400px] xl:w-[450px] flex-shrink-0'
              >
                <ScrollCard data={item} />
              </div>
            ))}
          </CardSliderType_2>
        </ShouldRender>
        <ShouldRender check={!screens.lg}>
          <div
            className='flex space-x-4 hide-scrollbar'
            style={{ scrollBehavior: 'smooth', scrollbarWidth: 'none' }}
          >
            {ReadersCardsData?.map((item, index) => (
              <ScrollCard key={`${item?.name}-${index}`} data={item} />
            ))}
          </div>
        </ShouldRender>
      </div>
    </div>
  );
};

export default ReadersSection;
